var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'desktop-device': _vm.isDesktop,
  'auth-page': _vm.isAuthPage,
  'has-tabbar': _vm.hasTabbar
},attrs:{"id":"app"}},[_c('router-view'),_c('Footer'),(_vm.isDesktop)?_c('div',{staticClass:"desktop-tip"},[_c('span',[_vm._v(_vm._s(_vm.$t('desktopMobilePage')))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }